module.exports = __webpack_public_path__ + "img/desktop_0.c326e4e9.png";